<template>
    <div class="product-card-link">
        <router-link :to="'/product/' + product.slug" >
            <div class="product-item text-center">
                <div class="featured-tag"  v-if="product.featured">
                    <div class="featured-mark" >
                        <p>Featured</p>
                    </div>
                    <div id="triangle-top-left"></div>
                </div>
                
                <div v-else class="padder"></div>
                <div class="product-card-image">
                    
                    <img :src=product.main_picture.formats.thumbnail.url :alt=product.main_picture.alternativeText>
                </div>
                
                <h5><strong>{{product.Name}}</strong></h5>
                
            </div>
            
        </router-link>
    </div>
    
</template>
<script>
export default {
    name: "Productcard",
    props: {
        product: Object
    }
}
</script>
<style lang="scss" scoped>

.product-card-link{
    height: 100%;
    .product-item{
        height: 100%;
        transition: 0.2s;
        padding: 8px;
        border: 2px solid #eeeeee;
        color: #182e5a;
        display: flex;
        flex-direction: column;

        &:hover{
            cursor: pointer;
            transition: 0.2s;
            box-shadow: 0 10px 30px -16px rgb(0 0 0 / 24%), 0 16px 20px -10px rgb(0 0 0 / 20%);
            transform: translate(0px, -8px);
        }

        .featured-tag{
            text-align: left;
            max-width: 96px;
            display: flex;
            flex-direction: row;

            .featured-mark{
                color: #eeeeee;
                padding: 0px 8px;
                background-color: #182e5a;
                p {
                    margin: 0;
                    font-style: italic;
                }
            }
             #triangle-top-left {
                width: 0;
                height: 0;
                border-top: 24px solid #182e5a;
                border-right: 24px solid transparent;
            }
        }

        

        .padder{
            margin-top: 24px;
        }
        
        .product-card-image{
            img{
                margin: auto;
            }
        }
        
    }
}

</style>